import type { CalculatorAction, CalculatorState } from "./types"
import { calculateResult } from "./helpers"

export const initialState: CalculatorState = {
  mode: "installment",
  installmentSum: 80000,
  cashbackSum: 10000,
  paymentResult: 0,
  minNum: 1000,
  maxNum: 500000,
  term: 24,
  terms: [3, 6, 10, 24],
  halvaDesyatka: true,
}

export const calculatorReducer = (
  state: CalculatorState,
  action: CalculatorAction
): CalculatorState => {
  switch (action.type) {
    case "SET_MODE": {
      const newState = {
        ...state,
        mode: action.payload,
        maxNum: action.payload === "cashback" ? 100000 : 500000,
      }
      return calculateResult(newState)
    }

    case "SET_SUM": {
      const updatedState = {
        ...state,
        [state.mode === "installment" ? "installmentSum" : "cashbackSum"]: action.payload,
      }
      return calculateResult(updatedState)
    }

    case "SET_TERM": {
      if (state.mode === "cashback") {
        return state
      }
      return calculateResult({ ...state, term: action.payload })
    }

    case "SET_HALVA_DESYATKA": {
      return calculateResult({ ...state, halvaDesyatka: action.payload })
    }

    default:
      return state
  }
}
